export default __webpack_public_path__ + "static/media/about-us-butterfly.2c2915b9.svg";